// Core
import React from "react";

function Question(props) {
   const { text } = props.data;

   return <p dangerouslySetInnerHTML={{ __html: text }}></p>;
}

export default Question;
